<template>
  <div class="container">
    <div v-if="isShow('date')" class="order-detail-summary__date content-row">
      <strong>Date </strong>
      <span>{{ formatDateTime(order.updated_at) }}</span>
    </div>
    <div v-if="isShow('id')" class="order-detail-summary__order-id content-row">
      <strong>Order ID </strong><span>{{ order.id }}</span>
    </div>
    <div v-if="isShow('orderNo')" class="order-detail-summary__order-no content-row">
      <strong>Order No </strong><span>{{ order.order_no }}</span>
    </div>
    <div v-if="isShow('items')" class="order-detail-summary__order-items items-container">
      <div
        v-for="orderItem in formatedOrderItems"
        :key="orderItem.id"
        class="order-detail-summary__order-item item"
      >
        <div class="item-name">
          <strong>{{ orderItem.name }}</strong>
        </div>
        <div class="content-row">
          <span class="item-mode">{{ orderItem.mode }}</span
          ><span class="item-price">{{ formatPrice(orderItem.price) }}</span>
        </div>
      </div>
    </div>
    <div v-if="isShow('quantity')" class="order-detail-summary__quantity content-row">
      <strong>Quantity </strong><span>{{ order.count_items }}</span>
    </div>
    <div v-if="isShow('totalPrice')" class="order-detail-summary__price content-row">
      <strong>Price </strong><span>{{ formatPrice(order.total_price, true) }}</span>
    </div>
    <div v-if="isShow('discount')" class="order-detail-summary__discount content-row">
      <strong>Total Discount </strong><span>{{ formatPrice(order.total_discount) }} </span>
    </div>
    <div
      v-if="payment && isShow('paymentMethod')"
      class="order-detail-summary__payment-method content-row"
    >
      <strong>Payment Method </strong><span>{{ formatPaymentMethod(payment.payment_method) }}</span>
    </div>
    <hr class="w-100" />
    <div v-if="isShow('totalAmount')" class="order-detail-summary__total-amount content-row">
      <strong>Total Amount </strong>
      <strong> {{ formatPrice(order.total_amount) }} </strong>
    </div>
  </div>
</template>

<script>
import Order from '@/models/Order';
import OrderItem from '@/models/OrderItem';
import Payment from '@/models/Payment';
import moment from 'moment';
export default {
  props: {
    order: {
      type: Order,
      default: null
    },
    payment: {
      type: Payment,
      default: null
    },
    hide: {
      type: Object,
      default: () => {
        return {
          date: false,
          id: false,
          orderNo: false,
          items: false,
          quantity: false,
          totalPrice: false,
          totalDiscount: false,
          paymentMethod: false,
          totalAmount: false
        };
      }
    }
  },
  computed: {
    formatedOrderItems() {
      const modeKey = {
        VERIFY_ENTRY: 'Verify',
        LEARN_VERIFY_ENTRY: 'Verify + Learn',
        VERIFY_QUOTA: 'Quota',
        LEARN_VERIFY_QUOTA: 'Learn + Quota'
      };

      return OrderItem.query()
        .with('learning_unit_option.learning_unit')
        .where('order_id', this.order.id)
        .get()
        .map((item) => {
          return {
            id: item.id,
            name: item.learning_unit_option.learning_unit.name,
            mode: modeKey[
              `${item.learning_unit_option.mode}_${item.learning_unit_option.option_type}`
            ],
            price: item.price_discount !== null ? item.price_discount : item.price
          };
        });
    }
  },
  methods: {
    isShow(field) {
      return this.hide[field] !== true;
    },
    formatDateTime(date) {
      return moment(date).format('MMM D, YYYY hh:mm a');
    },
    formatPaymentMethod(method) {
      const key = {
        CREDIT_CARD: 'Credit Card',
        QR_PAYMENT: 'QR Payment'
      };
      return key[method] || '-';
    },
    formatPrice(number, isTotal = false) {
      const price = Intl.NumberFormat('en-US', {
        currency: 'USD'
      }).format(number);

      if (isTotal && price === '0') {
        return 'FREE';
      } else {
        return `${price} THB`;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  border-radius: 10px;
}
.content-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}
.content-row span {
  opacity: 0.7;
}
.items-container {
  display: flex;
  flex-direction: column;
  margin-bottom: 0.5rem;
  gap: 0.5rem;
}
.items-container .item {
  background-color: #f7fbfc;
  border-radius: 5px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}
.item .content-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0;
}
.item .item-name {
  color: #4191ff;
  word-break: break-word;
  margin-bottom: 10px;
  text-align: left;
}
.item .item-price {
  font-weight: 500;
  opacity: 1;
  color: #666666;
}
</style>
